import React, { useEffect, useState } from 'react';
// import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Alert } from 'reactstrap';
import OperationalIssuesPanel from '../../features/operationalIssues/OperationalIssuesPanel';
import { getOperationalIssues, resolveOperationalIssue } from '../../redux/methods/integrations';

const propTypes =
{
    history: PropTypes.object,
    getOperationalIssues: PropTypes.func,
    resolveOperationalIssue: PropTypes.func,
};

type AdminHomeProps =
{
    history: { push: (path: string) => void }
    getOperationalIssues: (integrationKey: string) => Promise<any>
    resolveOperationalIssue: (key: string, values: { note: string }) => Promise<any>
}

const unwrapPayload = (result: any) => result?.payload ?? result;

const AdminHome = ({ history, getOperationalIssues, resolveOperationalIssue }: AdminHomeProps) =>
{
    const [googleMerchantIssues, setGoogleMerchantIssues] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadGoogleMerchantIssues = async () => {
        setIsLoading(true);

        try {
            const result = await getOperationalIssues('GoogleMerchant');
            const payload = unwrapPayload(result);

            setGoogleMerchantIssues(payload?.issues ?? []);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadGoogleMerchantIssues();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleResolveOperationalIssue = async (key: string) => {
        await resolveOperationalIssue(key, {
            note: 'Oznaczone jako rozwiązane ze strony głównej panelu administracyjnego.'
        });

        await loadGoogleMerchantIssues();
    };

    return (
        <Container fluid>
            <Row>
                <Col xs={12}>
                    <Card className="h-100">
                        <CardHeader className="d-flex justify-content-between align-items-center">
                            <span>
                                <i className="fa fa-shopping-bag mr-2" />
                                Google Merchant
                            </span>

                            <Button
                                type="button"
                                color="secondary"
                                size="sm"
                                outline
                                onClick={() => history.push('/integrations/comparisions/googleMerchant')}
                            >
                                Przejdź do integracji
                            </Button>
                        </CardHeader>

                        <CardBody>
                            {isLoading && (
                                <Alert color="info">
                                    Ładowanie statusu Google Merchant...
                                </Alert>
                            )}

                            {!isLoading && googleMerchantIssues.length === 0 && (
                                <Alert color="success">
                                    Brak aktywnych problemów Google Merchant.
                                </Alert>
                            )}

                            {!isLoading && googleMerchantIssues.length > 0 && (
                                <OperationalIssuesPanel
                                    issues={googleMerchantIssues}
                                    title=""
                                    onResolve={handleResolveOperationalIssue}
                                    compact={false}
                                />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

AdminHome.propTypes = propTypes;

const mapDispatch = {
    getOperationalIssues,
    resolveOperationalIssue
};

export default connect(null, mapDispatch)(AdminHome);